var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 108,
    viewBox: "0 0 127 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 31.9225V23.038C44.4727 14.1535 51.5591 6.85547 60.5494 6.85547C69.3282 6.85547 76.6262 14.0477 76.6262 23.038V31.9225",
    stroke: "#CCCCCC",
    strokeWidth: 2.00335,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4727 97.9214C99.8957 97.7099 100.001 97.4983 100.425 97.3926",
    stroke: "#148B77",
    strokeWidth: 0.647618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 106.383H125.704",
    stroke: "#CCCCCC",
    strokeWidth: 2.11536,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84766 106.383H6.50146",
    stroke: "#CCCCCC",
    strokeWidth: 2.11536,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.509 15.1055H17.3945V105.431H107.509V15.1055Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.72 15.1055H42.4609V105.431H107.614V15.1055H107.72Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8752 15.1055H17.3945V105.431H29.8752V15.1055Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4616 105.431H17.3945V105.219L30.0867 92.6328L42.4616 105.431Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2202 35.2012C60.0183 35.2012 61.499 33.7204 61.499 31.9224C61.499 30.1243 60.0183 28.6436 58.2202 28.6436C56.4222 28.6436 54.9414 30.1243 54.9414 31.9224C54.9414 33.7204 56.4222 35.2012 58.2202 35.2012Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3765 35.2012C92.1745 35.2012 93.6553 33.7204 93.6553 31.9224C93.6553 30.1243 92.1745 28.6436 90.3765 28.6436C88.5784 28.6436 87.0977 30.1243 87.0977 31.9224C87.2034 33.7204 88.5784 35.2012 90.3765 35.2012Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2227 31.9225V23.038C58.2227 14.1535 65.3091 6.85547 74.2994 6.85547C83.0782 6.85547 90.3762 14.0477 90.3762 23.038V31.9225",
    stroke: "#CCCCCC",
    strokeWidth: 2.00335,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.63 3.21571C102.914 1.75156 105.608 0.931641 108.478 0.931641C116.325 0.931641 122.709 7.25676 122.709 15.1046C122.709 22.9524 116.325 29.2775 108.478 29.2775C100.63 29.2775 94.246 22.9524 94.246 15.1046C94.1289 10.1265 96.7058 5.79261 100.63 3.21571Z",
    fill: "#999999"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.472 21.4519C105.613 21.4519 103.184 18.885 103.184 15.0346C103.184 11.1841 105.613 8.75977 108.472 8.75977C111.331 8.75977 113.76 11.1841 113.76 15.0346C113.76 18.885 111.331 21.4519 108.472 21.4519ZM108.472 18.4572C109.473 18.4572 110.473 17.4589 110.473 15.0346C110.616 12.7528 109.473 11.6119 108.472 11.6119C107.471 11.6119 106.471 12.7528 106.471 15.0346C106.471 17.4589 107.471 18.4572 108.472 18.4572Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1225 60.902C60.4892 60.902 57.4373 58.5774 56.2746 55.2358C55.984 54.5094 56.42 53.783 57.1466 53.4924C57.8733 53.2018 58.5999 53.6377 58.8906 54.3641C59.6172 56.5434 61.7972 58.1415 64.1225 58.1415C66.4478 58.1415 68.6277 56.6887 69.3544 54.3641C69.645 53.6377 70.3717 53.2018 71.0983 53.4924C71.825 53.783 72.261 54.5094 71.9703 55.2358C70.8077 58.7227 67.7557 60.902 64.1225 60.902Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0639 60.902C82.4306 60.902 79.3787 58.5774 78.216 55.2358C77.9254 54.5094 78.3614 53.783 79.088 53.4924C79.8147 53.2018 80.5413 53.6377 80.832 54.3641C81.5586 56.5434 83.7386 58.1415 86.0639 58.1415C88.3892 58.1415 90.5691 56.6887 91.2958 54.3641C91.5864 53.6377 92.3131 53.2018 93.0397 53.4924C93.7664 53.783 94.2024 54.5094 93.9117 55.2358C92.7491 58.7227 89.6971 60.902 86.0639 60.902Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1668 78.6919C77.0129 78.6919 78.5094 77.1959 78.5094 75.3504C78.5094 73.5049 77.0129 72.0088 75.1668 72.0088C73.3207 72.0088 71.8242 73.5049 71.8242 75.3504C71.8242 77.1959 73.3207 78.6919 75.1668 78.6919Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.288 4.91689V-0.000976562H33.2947V4.91689L20.3254 20.5647H33.5183V25.4825H13.6172V20.5647L26.5864 4.91689H14.288Z",
    fill: "#999999"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9394 41.8014V38.6719H42.2378V41.8014L33.9643 51.8607H42.4614V54.9903H29.4922V51.8607L37.7657 41.8014H29.9394Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ebe03fad120ad3566d757e312076b8a1.svg";
export { ForwardRef as ReactComponent };